import { useMemo } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { useTranslation } from '@/hooks/useTranslation';

export const BooleanSelector = ({
  onChange,
  value,
}: {
  onChange: (value: string) => void;
  value?: string;
}) => {
  const { t } = useTranslation('common');

  const values = useMemo(
    () => [
      { title: t('yes'), value: 'yes' },
      { title: t('no'), value: 'no' },
    ],
    [t]
  );

  const selectedValue = useMemo(
    () => values.find((v) => v.value === value),
    [value, values]
  );

  return (
    <Select onValueChange={(v) => onChange(v)}>
      <SelectTrigger>
        <SelectValue placeholder={selectedValue?.title ?? t('selectAValue')} />
      </SelectTrigger>
      <SelectContent>
        {values.map((v) => (
          <SelectItem key={v.value} value={v.value}>
            {v.title}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
